import { LegSource } from '../../../domain/models/heat-map/leg-source';

export class LegListSource {
  constructor(public source: LegSource, public toggled = true) {}
}
